import React, { useState, useEffect } from 'react';
import useStyle from './challengeButton.style';
import { classNames } from 'helpers/style/classNames';
import { getChallengeName } from '../../../../helpers/challenge/getChallengeName';

export interface ChallengeButtonProps {
  onClick: () => void;
  variant?: 'default' | 'autumn' | 'spring';
  year?: string;
  isMobileTopBar?: boolean;
}

export const ChallengeButton = ({
  onClick,
  variant = 'default',
  year = '',
  isMobileTopBar = false
}: ChallengeButtonProps) => {
  const [challengeName, setChallengeName] = useState(' ');
  const textContent = getChallengeName(variant, year);

  useEffect(() => {
    setChallengeName(textContent);
  }, [textContent]);

  const classes = useStyle();

  return (
    <button
      onClick={onClick}
      className={classNames(
        [classes.root, classes[variant]],
        [
          {
            condition: isMobileTopBar,
            classe: classes.noLeftRadius
          }
        ]
      )}
    >
      {challengeName}
    </button>
  );
};
